import React from 'react';
import { IProps } from './types';
import _ from 'lodash';

const ActivityNotes: React.FC<IProps> = (props) => props.notes && props.notes.length > 0 ? (
  <div className="activity-notes">
    <div className="template-container">
      <div className="template-content">
        <div className="activity-notes__title">活動注意事項</div>
        <ol>
          {
            _.map(props.notes, (note:string, index:number) => {
              return (
                <li key={index}>
                  <span>{`${index + 1}.`}</span>
                  <p>{note}</p>
                </li>
              );
            })
          }
        </ol>
      </div>
    </div>
  </div>
) : null;

export default ActivityNotes;
